import type { Shell } from '@/apilib';
import type { EntryPoint } from '@/apilib';
import { createExperimentsApi } from './api';
import { ExperimentsApiKey } from './publicApiKey';

export const ExperimentsEntrypoint: EntryPoint = {
  name: 'ExperimentsApi',
  declareAPIs: () => [ExperimentsApiKey],
  attach(shell: Shell) {
    shell.contributeAPI(ExperimentsApiKey, () => createExperimentsApi());
  },
};
